import universal from 'react-universal-component';

export default universal(() => import('./Top200PPR'));



// WEBPACK FOOTER //
// ./src/app/views/Top200PPR/index.js